import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/api';

const AdminProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isDashboardAuthenticated();
  const userToken = authService.getDashboardToken();
  
  // Verificar si el usuario tiene permisos de administrador
  const isAdmin = () => {
    try {
      if (!userToken) return false;
      
      // Decodificar el token JWT para verificar permisos
      const payload = JSON.parse(atob(userToken.split('.')[1]));
      return payload.es_administrador === true;
    } catch (error) {
      return false;
    }
  };

  if (!isAuthenticated) {
    return <Navigate to="/dashboard/login" />;
  }

  if (!isAdmin()) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="mt-2 text-sm font-medium text-gray-900">Acceso Denegado</h3>
            <p className="mt-1 text-sm text-gray-500">
              No tienes permisos de administrador para acceder a esta sección.
            </p>
            <div className="mt-6">
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminProtectedRoute;